// extracted by css-extract-rspack-plugin
export default {"cls1":"FocusedNavView-cls1_rkG","cls2":"FocusedNavView-cls2_Uch FocusedNavView-cls1_rkG"};